import {UI} from "../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../stem-core/src/ui/Style.js";

import {PaymentMethodIcon} from "../panel/pages/panels/payment-method/components/PaymentMethodIcon.jsx";
import {registerStyle} from "../../stem-core/src/ui/style/Theme.js";
import {styleRule} from "../../stem-core/src/decorators/Style.js";
import {isSmallScreen} from "../UtilsLib.js";
import {MessageElement} from "../widget/ui/MessageElement.jsx";
import {Messages} from "../Messages.js";


export function FormatPaymentMethodDescription(paymentMethod) {
    if (paymentMethod == null) {
        return Messages.walletFunds; // TODO This should still be a payment method
    }
    const lastDigits = paymentMethod.getLastDigits();
    if (lastDigits) {
        return Messages.usingCard(paymentMethod.getBrand(), lastDigits);
    }
    return paymentMethod.getBrand();
}


class PaymentMethodDetailsStyle extends StyleSheet {
    @styleRule
    cardDetails = {
        display: "flex",
        alignItems: "center",
    };

    @styleRule
    icon = {
        marginRight: () => (isSmallScreen() ? 6 : 24),
        display: "flex",
        alignItems: "baseline",
    };

    @styleRule
    cardNumber = {
        color: this.themeProps.MERCHANT_4,
    };
}

@registerStyle(PaymentMethodDetailsStyle)
export class PaymentMethodDetails extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            paymentMethod: null,
            iconSize: null,
            iconMargin: 0,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.cardDetails);
    }

    render() {
        const {paymentMethod, iconSize, iconMargin} = this.options;
        const {styleSheet} = this;

        const detailsMessage = FormatPaymentMethodDescription(paymentMethod);

        return [
            <PaymentMethodIcon brand={paymentMethod.getBrand()} className={styleSheet.icon} size={iconSize} style={{marginRight: iconMargin}}/>,
            <MessageElement className={styleSheet.cardNumber} message={detailsMessage} />
        ];
    }
}
